/** Stable keys aligned with `@valvur/shared-grpc` feature-flag catalog (browser-safe copy). */
export const IDENTITY_FEATURE_FLAG_KEY = {
  LAYER: 'identity.layer',
  FULLY_VERIFIED_REQUIRES_COURSE: 'identity.fully_verified.requires_course',
} as const;

export const IDENTITY_FEATURE_FLAG_DESCRIPTION: Record<
  (typeof IDENTITY_FEATURE_FLAG_KEY)[keyof typeof IDENTITY_FEATURE_FLAG_KEY],
  string
> = {
  [IDENTITY_FEATURE_FLAG_KEY.LAYER]:
    'Master switch for the Valvur identity layer: verification tiers, KYC orchestration, and identity policy evaluation.',
  [IDENTITY_FEATURE_FLAG_KEY.FULLY_VERIFIED_REQUIRES_COURSE]:
    'When enabled (with identity.layer on), FULLY_VERIFIED requires completion of all published courses flagged identity_mandatory in cs_course.',
};
